export const Key_For_Player_XState_Persistence = 'Key_For_Player_XState_Persistence'
export const Key_For_Host_XState_Persistence = 'Key_For_Host_XState_Persistence'